export default __webpack_public_path__ + "static/media/desktop.db30baca.jpg";